export class User {
	id: number;
	email: string;
	username: string;
	password: string;
}



// WEBPACK FOOTER //
// ./src/app/user.ts